import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiMemberTypeRequest() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const fileAuthAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    responseType: "arraybuffer",
  });

  const url = BASEURL + "member/";
  return {
    GetMubtadiToMultazimFormData: (data) =>
      authAxios.post(url + "GetMubtadiToMultazimFormData/", data),
    GetMemberAsTawajahTalabFormData: (data) =>
      authAxios.post(url + "GetMemberAsTawajahTalabFormData/", data),
    DeclareMubtadiToMultazimForm: (model) =>
      fileAuthAxios.post(url + "DeclareMubtadiToMultazimForm/", model),
    DeclareMemberAsTawajahTalabForm: (model) =>
      fileAuthAxios.post(url + "DeclareMemberAsTawajahTalabForm/", model),
    DeclareMemberToMutazirForm: (model) =>
      fileAuthAxios.post(url + "DeclareMemberToMutazirForm/", model),
    DeclareMemberAsMutazirForm: (model) =>
      fileAuthAxios.post(url + "DeclareMemberAsMutazirForm/", model),
    DeclareMemberMultazimForm: (model) =>
      fileAuthAxios.post(url + "DeclareMemberMultazimForm/", model),
    DeclareMemberAsMutazirFormData: (data) =>
      authAxios.post(url + "DeclareMemberAsMutazirFormData/", data),
    ForwardMemberTypeRequest: (values) =>
      authAxios.post(url + "ForwardMemberTypeRequest/", values),
    ApproveMemberChangeRequest: (values) =>
      authAxios.post(url + "ApproveMemberChangeRequest/", values),
  };
}
